import React, { useEffect, useState } from "react";

import ResourcesContext from "./ResourcesContext";
import { useApi } from "../api";
import { useAuth } from "../auth";

const ResourcesProvider = ({ children }) => {
  const api = useApi();
  const { user } = useAuth();
  const [smsGateways, setSmsGateways] = useState([]);
  const [contentTypes, setContentTypes] = useState([]);
  const [contentDensities, setContentDensities] = useState([]);
  const [tankGeometries, setTankGeometries] = useState([]);
  const [mobileProviders, setMobileProviders] = useState([]);
  const [reload, doReload] = useState(false);

  useEffect(() => {
    if (user) {
      doReload(true);
    }
  }, [user]);

  useEffect(() => {
    async function fetchSmsGateways() {
      doReload(false);

      const response = await api.get("/v2/sms-gateways");
      setSmsGateways(response.data);
    }

    async function fetchContentTypes() {
      doReload(false);

      const response = await api.get("/v2/content-types");
      setContentTypes(response.data);
    }

    async function fetchContentDensities() {
      doReload(false);

      const response = await api.get("/v2/content-densities");
      setContentDensities(response.data);
    }

    async function fetchTankGeometries() {
      // For now, these are hardcoded
      setTankGeometries([1, 2, 3, 4, 5, 6, 7, 8, 9]);
    }

    async function fetchMobileProviders() {
      doReload(false);

      const response = await api.get("/v2/mobile-providers");
      setMobileProviders(response.data);
    }

    if (reload) {
      fetchSmsGateways();
      fetchContentTypes();
      fetchContentDensities();
      fetchMobileProviders();
      fetchTankGeometries();
    }
  }, [api, reload]);

  return (
    <ResourcesContext.Provider
      value={{
        smsGateways,
        contentTypes,
        contentDensities,
        mobileProviders,
        tankGeometries
      }}
    >
      {children}
    </ResourcesContext.Provider>
  );
};

export default ResourcesProvider;
